import { Controller } from "@hotwired/stimulus"

// Sends a Google Analytics 4 event for the site's two calls to action.
//
// Usage:
//   <a data-controller="analytics"
//      data-action="click->analytics#track"
//      data-analytics-event-param="book_call_click"
//      data-analytics-location-param="sidebar">Book a call</a>
//
// Events: book_call_click, newsletter_open (mobile sheet opened),
// newsletter_subscribe (form submitted). `location` says where on the page
// it happened (sidebar, cta_bar, sheet). Mark book_call_click and
// newsletter_subscribe as key events in GA4 to see them as conversions.
export default class AnalyticsController extends Controller {
  track(event) {
    const { event: name, location } = event.params
    if (!name || typeof window.gtag !== "function") return

    window.gtag("event", name, {
      location: location || "unknown",
      page_path: window.location.pathname,
      // Book a call and Subscribe both leave the page, so send the hit
      // with sendBeacon and don't wait for a callback.
      transport_type: "beacon",
    })
  }
}
